import { render, staticRenderFns } from "./icon-configurator-energy-compatibility-6.svg?vue&type=template&id=8a127fec&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports